import type { ReactNode } from 'react'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn, Fetcher, RowAction } from '@/components/DataTable/types'
import { PERMISSIONS } from '@/lib/permissions'

/**
 * A6 list-ekranlar uchun umumiy prezentatsion qobiq: PageHeader + DataTable
 * (fail-soft fetcher, exportable). Har ekran faqat ustun + fetcher e'lon qiladi
 * → 20 ekran bir xil ko'rinadi (X1). Permission = USERS_VIEW (moderatsiya moduli).
 */
export function ModListScreen<T>({
  screenId,
  title,
  description,
  columns,
  fetcher,
  rowId,
  icon,
  rowActions,
  actions,
}: {
  screenId: string
  title: string
  description?: string
  columns: AdminColumn<T>[]
  fetcher: Fetcher<T>
  rowId: (row: T) => string
  icon?: ReactNode
  rowActions?: RowAction<T>[]
  actions?: ReactNode
}) {
  return (
    <>
      <PageHeader
        title={title}
        screenId={screenId}
        {...(description ? { description } : {})}
        {...(actions ? { actions } : {})}
      />
      <DataTable<T>
        screenId={screenId}
        permission={PERMISSIONS.USERS_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={rowId}
        exportable
        {...(rowActions ? { rowActions } : {})}
        {...(icon ? { emptyState: { icon } } : {})}
      />
    </>
  )
}
